var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOnboardingTopBackground = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 340,
  height: 208,
  viewBox: "0 0 340 208",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M328.804 177.201L14.1193 207.928C6.59565 208.659 0 203.735 0 197.395V7.99999C0 3.58171 3.58172 0 8 0H332C336.418 0 340 3.58172 340 8V166.669C340 172.052 335.19 176.579 328.804 177.201Z",
  fill: "url(#paint0_linear_26144_111730)",
  fillOpacity: 0.16
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_26144_111730",
  x1: 0,
  y1: 0,
  x2: 361.326,
  y2: 165.313,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#079D56"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#48F2A2",
  stopOpacity: 0.6
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOnboardingTopBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/onboarding-top-background.75fb2bedcbd4d1c9c46292fe63348d62.svg";